module.exports = __webpack_public_path__ + "img/feedback1.b03c338f.png";